import { createAction } from 'redux-actions';

export const SET_EXPERIMENT = 'SET_EXPERIMENT';

export const setExperiment = createAction(SET_EXPERIMENT);
